import { Component, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TenantContextService } from 'src/app/shared/tenant-context/tenant-context.service';

// Derived from Cashmere breadcrumbs:
// https://cashmere.healthcatalyst.net/web/components/breadcrumbs/
export interface IBreadcrumb {
    label: string;
    routerLink: any[] | null;
}

@Component({
    selector: 'cdp-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss'],
    standalone: false
})
export class BreadcrumbsComponent {
    @Input() tenantCode?: string = '';
    @Input() navbarTabName = '';
    @Input() breadcrumbs: IBreadcrumb[] = [];
    @Input() hasTenantContext = true;
    get showTenantSwitcher(): boolean {
        return this.tenantContext.showTenantSwitcher;
    }

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private tenantContext: TenantContextService
    ) {}

    getRouterLink(commands: any[]): string {
        const urlTree = this.router.createUrlTree(commands, {
            relativeTo: this.route
        });
        return this.router.serializeUrl(urlTree);
    }
}
